import { render, staticRenderFns } from "./authuser_add.vue?vue&type=template&id=6f6bd4d0&"
import script from "./authuser_add.vue?vue&type=script&lang=ts&"
export * from "./authuser_add.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports